import Text from '@atoms/Text';
import {theme} from '@styles/theme';
import {ReactComponent as Logo} from '@assets/logo.svg';
import Input from '@atoms/Input';
import {useState} from 'react';
import Button from '@atoms/Button';
import {Group, ViewFilled, ViewOffFilled, WarningFilled} from '@carbon/icons-react';
import IconWithBackground from '@atoms/IconWithBackground';
import {ERoutes} from '@constants/routes';
import {useNavigate, useSearchParams} from 'react-router';
import {
  AuthPageWrapper,
  AuthPageFieldsWrapper,
  AuthPageErrorWrapper,
  AuthPageMainContentWrapper,
  AuthPageContentWrapper,
} from '@pages/AuthPage.styles';
import {recoveryPasswordSet} from '@store/slices/users';
import {toast} from 'react-toastify';
import Toast from '@atoms/Toast';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '@store';

export const NewPasswordPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const email = searchParams.get('email');
  const [newPasswordValue, setNewPasswordValue] = useState<string>();
  const [repeatPasswordValue, setRepeatPasswordValue] = useState<string>();
  const [newPasswordFieldType, setNewPasswordFieldType] = useState<'password' | 'text'>(
    'password',
  );
  const [repeatPasswordFieldType, setRepeatPasswordFieldType] = useState<
    'password' | 'text'
  >('password');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const onSave = () => {
    if (email && code && newPasswordValue) {
      dispatch(recoveryPasswordSet({email, code, password: newPasswordValue}))
        .unwrap()
        .then(() => {
          setSuccess(true);
        })
        .catch((err: any) => {
          toast.error(
            <Toast
              title="Ошибка"
              text={err?.message || 'Не удалось изменить пароль'}
              type="error"
            />,
          );
        });
    }
  };

  return (
    <AuthPageWrapper>
      <AuthPageContentWrapper>
        <AuthPageMainContentWrapper>
          {!success && (
            <>
              <Logo />
              <Text text="Установите новый пароль" type="titleR" />
              <Text
                text="Придумайте новый пароль для безопасного доступа к вашему аккаунту."
                align="center"
              />
              <AuthPageFieldsWrapper>
                <Input
                  id="password"
                  label="Введите новый пароль"
                  type={newPasswordFieldType}
                  value={newPasswordValue}
                  onChange={e => {
                    setError('');
                    setNewPasswordValue(e.currentTarget.value);
                  }}
                  iconElement={
                    newPasswordFieldType == 'password' ? (
                      <ViewOffFilled size={16} color={theme.colors.basic02} />
                    ) : (
                      <ViewFilled size={16} color={theme.colors.basic02} />
                    )
                  }
                  onClickIcon={() =>
                    setNewPasswordFieldType(
                      newPasswordFieldType == 'password' ? 'text' : 'password',
                    )
                  }
                  withoutErrorText
                  error={error}
                />
                <Input
                  id="repeatPassword"
                  label="Подтвердите пароль"
                  type={repeatPasswordFieldType}
                  value={repeatPasswordValue}
                  onChange={e => {
                    setError('');
                    setRepeatPasswordValue(e.currentTarget.value);
                  }}
                  iconElement={
                    repeatPasswordFieldType == 'password' ? (
                      <ViewOffFilled size={16} color={theme.colors.basic02} />
                    ) : (
                      <ViewFilled size={16} color={theme.colors.basic02} />
                    )
                  }
                  onClickIcon={() =>
                    setRepeatPasswordFieldType(
                      repeatPasswordFieldType == 'password' ? 'text' : 'password',
                    )
                  }
                  withoutErrorText
                  error={error}
                />
                {error && (
                  <AuthPageErrorWrapper>
                    <WarningFilled size={14} fill={theme.colors.signalRed00} />
                    <Text text={error} type="tinyR" color={theme.colors.signalRed00} />
                  </AuthPageErrorWrapper>
                )}
              </AuthPageFieldsWrapper>
              <Button
                title="Продолжить"
                variant="filled"
                type="submit"
                size="big"
                onClick={() =>
                  newPasswordValue === repeatPasswordValue
                    ? onSave()
                    : setError('Пароли не совпадают')
                }
                fullWidth
                disabled={!newPasswordValue || !repeatPasswordValue}
              />
            </>
          )}
          {success && (
            <>
              <IconWithBackground
                icon={<Group size={28} fill={theme.colors.accent00} />}
                successMark
              />
              <Text text="Готово" type="titleR" />
              <Text
                text="Теперь вы можете авторизоваться используя новый пароль."
                align="center"
              />
              <Button
                title="Авторизация"
                variant="filled"
                size="big"
                fullWidth
                onClick={() => navigate(ERoutes.AUTHORIZATION)}
              />
            </>
          )}
        </AuthPageMainContentWrapper>
      </AuthPageContentWrapper>
    </AuthPageWrapper>
  );
};

export default NewPasswordPage;
